import { render, staticRenderFns } from "./RightMenuSettingTable.vue?vue&type=template&id=51d4760a"
import script from "./RightMenuSettingTable.vue?vue&type=script&lang=js"
export * from "./RightMenuSettingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports